import React, { Component } from 'react';
import { connect } from 'react-redux';
import './updateProfile.scss';
import { Button, message } from 'antd';
import NoImage from "../../../images/no-image.jpg";
import EditIcon from "../../../images/edit-icon.png";
import { saveExperience, uploadExperience, deleteExperience } from '../action/user.actions'
import { fromValidate } from '../../../helpers';
import _ from 'lodash';
import { Table, Modal, DatePicker } from 'antd';
import { imageEndpoint } from '../../../services/endpoint';
import moment from 'moment';


class ExperienceDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      experience: {
        organization_name: '',
        organization_address: '',
        relieving_date: '',
        last_working_day: '',
        last_drawn_salary: '',
        job_type: '',
        designation: '',
        reason_for_leaving: '',
        reporting_to: '',
        ro_contact_no: '',
        is_relevant: ''
      },
      document: {},
      formError: {},
      visibleExperience: false,
      experienceColumns: [
        {
          title: 'Organization Name',
          dataIndex: 'organization_name',
        },
        {
          title: 'Organization Address',
          dataIndex: 'organization_address',
        },
        {
          title: 'Designation',
          dataIndex: 'designation',
        },
        {
          title: 'Date of Joining',
          dataIndex: 'relieving_date',
        },
        {
          title: 'Actions',
          dataIndex: '',
          render: (text, obj) => <div className='action'>
            <span onClick={() => { this.onEditExperience(obj) }}>Edit</span>
            <span onClick={() => { this.onDeleteExperience(obj) }}>Delete</span>
          </div>
        },
      ]
    }
  }

  componentDidMount() {
  }

  onEditExperience = (obj) => {

    if (obj.relieving_date) {
      obj.relieving_date = moment(obj.relieving_date, 'YYYY-MM-DD');
    }
    if (obj.last_working_day) {
      obj.last_working_day = moment(obj.last_working_day, 'YYYY-MM-DD');
    }
    this.setState({
      experience: obj,
      document: {},
      visibleExperience: true
    })
  }

  onDeleteExperience = (obj) => {
    const { user, dispatch } = this.props;
    dispatch(deleteExperience(user.id, obj.id));
  }

  handleChange = (e) => {
    const experience = Object.assign({}, this.state.experience)
    const name = e.target.name;
    const value = e.target.value;
    experience[name] = value;
    this.setState({ experience });
  }

  handleDateChange = (name, value) => {
    const experience = Object.assign({}, this.state.experience)
    experience[name] = value;
    this.setState({ experience });
  }

  createFormData = (body) => {
    let data = new FormData();
    Object.keys(body).forEach(key => {
      data.append(key, body[key]);
    });
    return data;
  };

  onSelectFile = (e) => {
    const { user } = this.props;
    const document = Object.assign({}, this.state.document)
    let file = e.target.files[0];
    if (file) {
      document.photo = file;
      document.user_id = user.id;
      document.document_type = file.type;
      document.document_name = document.document_name || 'Certificate';
      this.setState({ document: document })
    }
    // dispatch(uploadIdentityverification(user.id, formData))
  }

  onSelectDocumentName = (e) => {
    const document = Object.assign({}, this.state.document);
    document.document_name = e.target.value;
    this.setState({ document: document })
  }



  handleOkExperience = e => {
    const { user, dispatch } = this.props;
    let { experience, document } = this.state;
    e.preventDefault();
    this.setState({ formError: {}, formSubmit: true })
    const formValidation = fromValidate(this.fromNode);
    if (!formValidation.valid) {
      this.setState({ formError: formValidation.invalidationEle })
    }
    else {
      experience.user_id = user.id;
      if (experience.relieving_date) {
        experience.relieving_date = experience.relieving_date.format('YYYY-MM-DD')
      }
      if (experience.last_working_day) {
        experience.last_working_day = experience.last_working_day.format('YYYY-MM-DD')
      }

      dispatch(saveExperience(user.id, experience))
        .then((res) => {

          if (document && document.photo) {
            const newdata = res.experience.find((qul) => {
              return qul.organization_name == experience.organization_name
            })
            let fromData = this.createFormData(document)
            dispatch(uploadExperience(user.id, fromData, newdata.id))
          }
          this.handleCancelExperience();
        });
    }
  };

  showModalExperience = () => {
    this.setState({
      experience: {
        organization_name: '',
        organization_address: '',
        relieving_date: '',
        last_working_day: '',
        last_drawn_salary: '',
        job_type: '',
        designation: '',
        reason_for_leaving: '',
        reporting_to: '',
        ro_contact_no: '',
        is_relevant: ''
      },
      document: {},
      visibleExperience: true,
      formError: {},
    });
  };

  handleCancelExperience = e => {
    console.log(e);
    this.setState({
      experience: {
        organization_name: '',
        organization_address: '',
        relieving_date: '',
        last_working_day: '',
        last_drawn_salary: '',
        job_type: '',
        designation: '',
        reason_for_leaving: '',
        reporting_to: '',
        ro_contact_no: '',
        is_relevant: ''
      },
      document: {},
      visibleExperience: false,
      formError: {},
    });
  };


  render() {
    const { user } = this.props;
    const { experience, experienceColumns, formError } = this.state;
    const document = (experience && experience.documents) || [];
    const doc = _.first(document);

    return (
      <div className="form-main-cont-box">
        <div className="upprof-heading-txt">Experienceal Detail</div>


        <div className="">
          <div>
            <Button className='btn-added-right' onClick={this.showModalExperience}>
              Add Experience
						</Button>
          </div>
          <Table
            columns={experienceColumns}
            dataSource={user.experience || []}
          />
          <Modal
            title="Experience"
            visible={this.state.visibleExperience}
            onOk={this.handleOkExperience}
            onCancel={this.handleCancelExperience}
          >
            <div className="">
              <form ref={node => this.fromNode = node} noValidate autoComplete="off">
                <div className="row row-padding">
                  <div className="col-12">
                    <input
                      type="text"
                      className='prof-textfield-containt'
                      placeholder="Organization Name"
                      name="organization_name"
                      required
                      value={experience.organization_name}
                      onChange={(e) => { this.handleChange(e) }}
                    />
                    {formError && formError['organization_name'] && <div className="error-msg">Required</div>}
                    <input
                      type="text"
                      className='prof-textfield-containt'
                      placeholder="Organization Address"
                      required
                      name="organization_address"
                      value={experience.organization_address}
                      onChange={(e) => { this.handleChange(e) }}
                    />
                    {formError && formError['organization_address'] && <div className="error-msg">Required</div>}
                    <div className="row">
                      <div className="col-6">
                        <DatePicker
                          className='experience-date-picker-box'
                          placeholder="Joining Date"
                          required
                          name="relieving_date"
                          value={experience.relieving_date}
                          onChange={(e) => { this.handleDateChange('relieving_date', e) }}
                        />
                        {formError && formError['relieving_date'] && <div className="error-msg">Required</div>}
                      </div>
                      <div className="col-6">
                        <DatePicker
                          className='experience-date-picker-box'
                          placeholder="Last Working Date"
                          name="last_working_day"
                          value={experience.last_working_day}
                          onChange={(e) => { this.handleDateChange('last_working_day', e) }}
                        />
                        {formError && formError['last_working_day'] && <div className="error-msg">Required</div>}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6">
                        <input
                          type="number"
                          className='prof-textfield-containt'
                          placeholder="Last Drawn Salary"
                          name="last_drawn_salary"
                          value={experience.last_drawn_salary}
                          onChange={(e) => { this.handleChange(e) }}
                        />
                      </div>
                      <div className="col-6">
                        <select
                          required
                          className='prof-textfield-containt'
                          placeholder="Job Type"
                          name="job_type"
                          value={experience.job_type}
                          onChange={(e) => { this.handleChange(e) }}
                        >
                          <option label="Job Type" value={0} />
                          <option label="Full Time" value="Full Time" />
                          <option label="Part Time" value="Part Time" />
                        </select>
                        {formError && formError['job_type'] && <div className="error-msg">Required</div>}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-6">
                        <input
                          type="text"
                          className='prof-textfield-containt'
                          placeholder="Designation"
                          required
                          value={experience.designation}
                          name="designation"
                          onChange={(e) => { this.handleChange(e) }}
                        />
                        {formError && formError['designation'] && <div className="error-msg">Required</div>}
                      </div>
                      <div className="col-6">
                        <input
                          type="text"
                          className='prof-textfield-containt'
                          placeholder="Reason for Leaving"
                          required
                          name="reason_for_leaving"
                          value={experience.reason_for_leaving}
                          onChange={(e) => { this.handleChange(e) }}
                        />
                        {formError && formError['reason_for_leaving'] && <div className="error-msg">Required</div>}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-6">
                        <input
                          type="text"
                          className='prof-textfield-containt'
                          placeholder="Reporting To"
                          required
                          name="reporting_to"
                          value={experience.reporting_to}
                          onChange={(e) => { this.handleChange(e) }}
                        />
                        {formError && formError['reporting_to'] && <div className="error-msg">Required</div>}
                      </div>
                      <div className="col-6">
                        <input
                          type="number"
                          className='prof-textfield-containt'
                          placeholder="RO Contact No."
                          required
                          name="ro_contact_no"
                          value={experience.ro_contact_no}
                          onChange={(e) => { this.handleChange(e) }}
                        />
                        {formError && formError['ro_contact_no'] && <div className="error-msg">Required</div>}
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div>
                      <div className="doc-img-box">
                        <div className="upload-btn-wrapper">
                          <img src={EditIcon} className="doc-edit-icon" alt="" />
                          <input type="file" name="myfile" onChange={(e) => { this.onSelectFile(e) }} />
                        </div>
                        <img src={doc && doc.document_url ? imageEndpoint + doc.document_url : NoImage} className="update-prof-img-box" alt="" />
                      </div>
                      <label className="redio-lavel-txt" >Upload Document</label>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </Modal>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  }
}
export default connect(mapStateToProps)(ExperienceDetail);